import * as React from 'react'

import Card                 from '@material-ui/core/Card'
import CardActions          from '@material-ui/core/CardActions'
import CardContent          from '@material-ui/core/CardContent'
import Divider              from '@material-ui/core/Divider'
import {
  createStyles,
  Theme, WithStyles,
  withStyles,
}                           from '@material-ui/core/styles/'
/* TODO
  import Edit from '@material-ui/icons/Edit'
*/
import { ActionButton }     from '../atoms'

interface Props {
  onRemove?: () => void
  children: JSX.Element,
}

const styles = (theme: Theme) => createStyles({
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
})

const InteractiveCard = ({
  classes,
  onRemove,
  children,
}: Props & WithStyles<typeof styles>) => {
  const removeAction = onRemove && (
    <ActionButton
      actionType={'remove'}
      onClick={onRemove}
      color={'primary'}
      size={'small'}
    />
  )

  return (
    <Card>
      <CardContent>
        {children}
      </CardContent>
      <Divider />
      <CardActions>
        {/*TODO: not sure how to do this yet
         <Button color={'primary'} size={'small'}>
           <Edit className={classes.leftIcon} />
           <FormattedMessage
             id={'buttonActions.edit'}
             defaultMessage={'edit'}
           />
         </Button>
        */}
        {removeAction}
      </CardActions>
    </Card>
  )
}

export default withStyles(styles)<Props>(InteractiveCard)



// WEBPACK FOOTER //
// ./src/components/molecules/InteractiveCard.tsx